module.exports = __webpack_public_path__ + "static/media/vent.20b5e75e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/vent.svg
// module id = 823
// module chunks = 0